module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loaderFull', {
    attrs: {
      "isFullActive": true
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92051c9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 1904
// module chunks = 1